import { extractQueryName } from "./../../utils/gql.mjs";
export function sourceMetaDataPlugin() {
  return function sourceMetaDataPlugin2({ opContext, operation }) {
    opContext.headers.source = `${process.server ? "server" : "browser"}`;
    const queryName = extractQueryName(operation);
    opContext.headers.queryType = operation.type;
    opContext.headers.queryName = queryName;
  };
}
